export default __webpack_public_path__ + "static/8523-81f881c895adc2420b3593fdaa75a85d.jpg";